import http from '@/http'
import { DraftImage } from '@/interfaces/admin/draftImage'

export async function getDraftSheets (pageId: string): Promise<DraftImage[]> {
  const { data } = await http.get(`/admin/draft-sheets/by-target-page/${pageId}`)
  return data
}
